export const SECTORS_TABLE_COLUMNS = [
  {
    key: 'name',
    title: 'Name',
  },
  {
    key: 'sentiment',
    title: 'News sentiment',
  },
  {
    key: 'sentimentChart',
    title: '',
  },
];

export default SECTORS_TABLE_COLUMNS;
